import { useEffect, useState } from 'react';
import { useTitleAndUser } from '../../../hooks/userTitle';
import { ButtonTab, SimuladoresContainer, TabPagesContent } from './styles';

import { JurosCompostos } from './JurosCompostos';
import { CalculadoraJurosEquivalente } from './CalculadoraJurosEquivalente';
import { CalculatorCDI } from './CalculatorCDI';
import SimuladorAposentadoria from './SimuladorAposentadoria/SimuladorAposentadoria';
import ComparadorRendaFixa from './ComparadorRendaFixa/ComparadorRendaFIxa';

export function Simulators() {
  // @ts-ignore
  const { setTitle } = useTitleAndUser();

  const [tabDefine, setTabDefine] = useState<
    | 'aposentadoria' | 'comparador-renda-fixa' | 'compostos' | 'equivalentes' | 'cdi' 
  >('aposentadoria');

  useEffect(() => {
    if (!location.pathname.includes('un-logged')) setTitle('Simuladores');
  }, []);

  return (
    <SimuladoresContainer>
      <TabPagesContent>
        <ButtonTab
          isActive={tabDefine === 'aposentadoria'}
          onClick={() => setTabDefine('aposentadoria')}
        >
          SIMULADOR<br /> APOSENTADORIA
        </ButtonTab>

        <ButtonTab
          isActive={tabDefine === 'comparador-renda-fixa'}
          onClick={() => setTabDefine('comparador-renda-fixa')}
        >
          COMPARADOR<br /> RENDA FIXA
        </ButtonTab>

        <ButtonTab
          isActive={tabDefine === 'compostos'}
          onClick={() => setTabDefine('compostos')}
        >
          JUROS<br /> COMPOSTOS
        </ButtonTab>

        <ButtonTab
          isActive={tabDefine === 'equivalentes'}
          onClick={() => setTabDefine('equivalentes')}
        >
          JUROS<br /> EQUIVALENTES
        </ButtonTab>

        <ButtonTab
          isActive={tabDefine === 'cdi'}
          onClick={() => setTabDefine('cdi')}
        >
          CALCULADORA<br /> DE CDI
        </ButtonTab>

        

      </TabPagesContent>

      {tabDefine === 'aposentadoria' && <SimuladorAposentadoria />}
      {tabDefine === 'comparador-renda-fixa' && <ComparadorRendaFixa />}
      {tabDefine === 'compostos' && <JurosCompostos />}
      {tabDefine === 'equivalentes' && <CalculadoraJurosEquivalente />}
      {tabDefine === 'cdi' && <CalculatorCDI />}
    </SimuladoresContainer>
  );
}